module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABHUlEQVQ4jeWQu0rDABSGv1yoiUqklYLVilNxEBx8C8HmNdxcfAFB8An0Nawm4FgFBUUQO7koLeKlhiZa25DUtDYOrVPSelkcPNv5z/m/c/jhr0sAMAwj/I1Z13VB/mzy+fyPzKZpAiAOW3KcJ+za41DQQIDvudxcbHF5vInnuQMBcpzY8Fzqzi3Vu1P8Vgfn5Z6KI7Ewm/sa4Adttou7jFt7FGprSEKX56MN3rRlJsYmyaZSUYBeSkLppKcEdcTXQ1ZzXcruA0lRoNLssnN+zfpZEZSpvjUZ/4FAiCaJWNUZprUCitfmyppDStgwkv5GBqKCN7rCe1ZjsTFPOqNy0Mzgd1rEZR4BhLJKIKvs2wBLYPcHiYi3dy9e/lf1ASC8XGMZdJgCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SM.png
// module id = 1265
// module chunks = 0